import { render, staticRenderFns } from "./singleCardQuery.vue?vue&type=template&id=45d7e3c6&"
import script from "./singleCardQuery.vue?vue&type=script&lang=js&"
export * from "./singleCardQuery.vue?vue&type=script&lang=js&"
import style0 from "./singleCardQuery.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports